import { useTranslation } from "react-i18next";
import { shallow } from "zustand/shallow";
import { useAccountStore } from "../../../../stores/accountStore";
import TeambookDialog from "../../../default_components/TeambookDialog";
import PropTypes from "prop-types";

const ExceedProjectsDialog = ({ open, handleClose }) => {
  const { t } = useTranslation();
  const [account] = useAccountStore((state) => [state.account], shallow);

  return (
    <TeambookDialog
      open={open}
      onClose={handleClose}
      title={t("projects.projects_exceeded_title")}
      withCloseButton
      content={
        <>
          <p className="exceeded-text">
            {t("projects.projects_exceeded_text_1")} {account?.subscription?.projects_available}{" "}
            {t("projects.projects_exceeded_text_2")}
          </p>

          <p>{t("projects.projects_exceeded_text_3")}</p>

          <p>
            {t("projects.projects_exceeded_text_4")} <a href="/settings">{t("projects.projects_exceeded_text_7")}</a>
          </p>

          <p>{t("projects.projects_exceeded_text_5")}</p>

          <p>
            {t("projects.projects_exceeded_text_6")}
            <a href="mailto:support@teambookapp.com">{t("header.support_email")}</a>
          </p>
        </>
      }
    />
  );
};

ExceedProjectsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default ExceedProjectsDialog;
